import { useCallback } from "react";

import type { InvoiceSystemSettingsInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { INVOICE_SYSTEM_SETTINGS_MUTATION } from "./schema";

type Props = {
	onResetViewModel: () => void;
};

export const useInvoiceSystemSettingsMutation = ({ onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(INVOICE_SYSTEM_SETTINGS_MUTATION);

	const onUpdateInvoiceSystemSettings = useCallback(
		async (input: InvoiceSystemSettingsInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({ variables: { input } }).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "インボイス制度に関する設定を更新しました",
				});
				onResetViewModel();
			}
		},
		[mutationFunc, showLoadingScreenCallback, hideLoadingScreenCallback, onResetViewModel],
	);

	return {
		onUpdateInvoiceSystemSettings,
	};
};
